<template>
  <div v-loading="pageLoading" class="Replacement">
    <el-input placeholder="请输入订单号" v-model="salesNumber" class="input-with-select">
      <el-button slot="prepend" @click="scanQrcode" icon="el-icon-full-screen"></el-button>
      <el-button slot="append" icon="el-icon-search" @click="searchSales"></el-button>
    </el-input>
    <div v-if="haveData">
        <el-divider content-position="left">
          <i class="el-icon-shopping-bag-1"></i>订单号：{{number}}
        </el-divider>
        <el-divider content-position="left">
          <i class="el-icon-user"></i>人员 {{ applicant }}
          <i class="el-icon-location-outline"></i>离厂基地：{{area}}
        </el-divider>
        <el-table
          v-loading="listLoading"
          :data="tableData"
          border
          fit
          highlight-current-row
          style="width: 100%;"
        >
          <el-table-column type="index"></el-table-column>
          <el-table-column label="产品名称" align="center">
            <template slot-scope="{row}">
              <span>{{ row.goodsName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center">
            <template slot-scope="{row}">
              <span>{{ row.goodsQuantity }}</span>
            </template>
          </el-table-column>
          <el-table-column label="图片">
            <template slot-scope="scope">
              <el-popover placement="top-start" title="" trigger="click">
                <img :src="scope.row.goodsSpec" alt="" style="width: 300px;height: 300px">
                <img slot="reference" :src="scope.row.goodsSpec" style="width: 50px;height: 50px">
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <el-divider content-position="center">
          <i class="el-icon-upload"></i>请上传出门产品图片
        </el-divider>
        <el-upload
            :action="this.$uploadURL"
            ref="upload"
            :with-credentials="false"
            :multiple="true"
            :accept="'image/*'"
            list-type="picture-card"
            :on-error="uploadError"
            :on-success="handleAvatarSuccess">
          <i slot="default" class="el-icon-plus"></i>
    <!--            <div slot="file" slot-scope="{file}" @click="clickIn" v-clickout="clickOut">-->
          <div slot="file" slot-scope="{file}">
            <el-progress v-show="file.percentage!=100" type="circle" :percentage="showfilepercentage(file.percentage)"></el-progress>
            <img
                class="el-upload-list__item-thumbnail"
                :src="file.url" alt="">
            <span class="el-upload-list__item-actions">
              <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
        <el-divider></el-divider>
        <el-button class="savebtn" type="primary" @click="subbmit('ruleForm')">确认</el-button>
    </div>
  </div>
</template>
<script>
    import wx from "weixin-js-sdk";
    export default {
        name: "InteriorSales",
        data() {
          return {
            pageLoading: false,  // 页面加载遮罩
            listLoading: false,
            fileUrlList: [],   // 图片
            appid:'',      // 公众号id
            haveData: false,
            salesNumber:'',
            number: '',
            userName: '',
            applicant: '',
            area: '',
            applyId: '',
            tableData: [],
          }
        },
        methods: {
          handleAvatarSuccess(response){
              this.fileUrlList.push(response);
          },
          handleRemove(file) {
              this.fileUrlList.splice(this.fileUrlList.indexOf(file.response),1);
              this.$refs.upload.handleRemove(file);
          },
          uploadError(error) {
            console.log("error",error);
          },
          showfilepercentage(per){
            return Math.floor(per);
          },
          subbmit() {
              let phone1 = "";
              let phone2 = "";
              if(this.fileUrlList.length<1){
                this.$message({
                    type: 'warning',
                    message: '请上传：出门产品照片',
                    offset: 60
                });
                return
              } else {
                if(this.fileUrlList.length==2){
                  phone1 = this.fileUrlList[0].replace("D://BCSS/pigeon-8083/webapps","https://bcss.gongniu.cn:8083")
                }else if(this.fileUrlList.length>2){
                  phone2 = this.fileUrlList[1].replace("D://BCSS/pigeon-8083/webapps","https://bcss.gongniu.cn:8083")
                }
              }
              this.pageLoading = true;
              const dataSelect = {
                "username":this.userName,
                "applyId":this.applyId,
                "photo":this.fileUrlList[0].replace("D://BCSS/pigeon-8083/webapps","https://bcss.gongniu.cn:8083"),
                "photo1":phone1,
                "photo2":phone2,
              }
              this.$axios.post(this.$baseURL + `/interiorSale/handleSales`,dataSelect)
                .then( res => {
                  console.log(res)
                  this.pageLoading = false;
                  if(res.data.code==1){
                    this.$message({
                        type: 'success',
                        message: '操作成功！',
                        offset: 60
                    });
                    this.haveData = false
                  }else{
                    this.$message({
                        type: 'warning',
                        message: '提交失败，请联系管理员!',
                        offset: 60
                    });
                  }
                })
                .catch(error=> {
                    console.log(error.response);
                    this.$message({
                        type: 'warning',
                        message: '提交失败，请重试或联系客服',
                        offset: 60
                    });
                    this.pageLoading = false;
                });
          },
          wechatConfig() {
            let url = encodeURIComponent(window.location.href.split('#')[0])
            this.$axios.get(this.$baseURL + '/incident/getWxConfig?url='+url).then(res=> {
              wx.config({
                debug: false,
                appId: res.data.appid, // 必填，公众号的唯一标识
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名
                jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
              });
              wx.ready(function() {
                wx.checkJsApi({
                    jsApiList: ['scanQRCode'],
                    success: function(res) {
                      console.log(res)
                      if (res.checkResult.scanQRCode == true) {
                          console.log('查询成功')
                      } else {
                          alert('抱歉，当前客户端版本不支持扫一扫,请升级到最新版本');
                      }
                    },
                    fail: function(res) {
                        alert('fail' + res);
                    }
                });
              });
            }).catch(error=> {
                console.log("：报错"+error);
            });
          },
          scanQrcode() {
            let this_ = this;
            wx.scanQRCode({
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
              success: function (res) {
                this_.salesNumber = res.resultStr
                this_.searchSales()
                // var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                // if (res.resultStr.indexOf('SN:') !== -1) {
                //   this_.replacementIncident.snCode = res.resultStr.replace('SN:', '');
                // } else {
                //   this_.replacementIncident.snCode = res.resultStr;
                // }
              }
            });
          },
          searchSales(){
            if(this.userName==undefined||this.userName==null||this.userName==''){
              this.$message({
                  type: 'warning',
                  message: '用户未登录！如有问题请联系管理员',
                  offset: 60
              });
            }
            const selectData = {
              "serialNumber": this.salesNumber,
              "username":this.userName
            }
            // this.$axios.post(`http://logistics.gongniuchazuo.net:8080/api/apiComm/findSales`,selectData)
            this.$axios.post(this.$baseURL + `/interiorSale/findSales`,selectData)
            // this.$axios.post( `/interiorSale/findSales`,selectData)
            .then( res => {
              const content = res.data
              if(res.data.length==undefined||res.data.length==0) {
                this.haveData = false
                this.$message({
                    type: 'warning',
                    message: '该订单查询无结果！如有问题请联系管理员',
                    offset: 60
                });
              } else if(content[0].nodeName=='归档'){
                this.$message.error('该订单产品已经出厂，请注意！');
              }else{
                this.number = content[0].serialNumber
                this.applicant = content[0].applicant
                this.applyId = content[0].id
                this.area = content[0].origin
                this.tableData = content[0].goods
                this.haveData = true
              }
              console.log(res)
              // this.pageLoading = false;
                // this.$confirm('您已提交成功，我们会尽快处理！', '', {
                //     confirmButtonText: '确定',
                //     showCancelButton: false,
                //     type: 'success',
                //     showClose: false,
                //     closeOnClickModal: false,
                //     customClass: 'message-logout'
                // }).then(() => {
                //     // 提交成功点击确定，刷新页面
                //     console.log("refresh");
                //     this.$router.go(0);
                // }).catch(() => {
                //     // DO NOTHING
                // });
            }).catch(error=> {
                console.log(error.response);
                // console.log(error.response.data.status);
                this.$message({
                    type: 'warning',
                    message: '查询失败，没有权限或者出厂基地不匹配！',
                    offset: 60
                });
                this.pageLoading = false;
            });
          }
        },
        created() {
            // 公众号appid
            // if (typeof this.$route.query.appid === 'undefined') {
            //     // 选择产品返回后，路由参数不再携带appid，此时主动刷新页面或提交成功后自动刷新页面，都需要从localstorage中获取appid
            //     this.appid = window.localStorage.getItem("fastappid");
            //     if(this.appid == null){
            //         // localstorage中也不存在appid，特殊情况，调用微信sdk关闭页面
            //         wx.closeWindow();
            //     }
            // }else {
            //     // 将url携带的appid存入localstorage
            //     this.appid = this.$route.query.appid;
            //     window.localStorage.setItem("fastappid",this.appid);
            // }
            var url = window.location.href.split('?')[1]
            this.userName = window.atob(url)
            this.wechatConfig()
        },
    };
</script>

<style scoped>
  .el-radio {
    margin: 10px 30px;
  }

  .rule-form {
    padding: 0px 10px;
    font-size: 13px;
  }

  .savebtn {
    margin-bottom: 20px;
  }
</style>
